import { atom } from "recoil";

export const tutorialStatusAtom = atom({
  key: "tutorialStatusAtom",
  default: false,
});
